@let resolvedIcon = icon();
<div class="relative inline-block w-full">
  @if (loading()) {
    <div
      class="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center z-1 text-nowrap"
    >
      <mat-spinner diameter="24" />
    </div>
  }

  <button
    class="w-full"
    mat-flat-button
    [class.text-nowrap]="textNoWrap()"
    [disabled]="loading()"
    [type]="type()"
    (click)="onClick()"
  >
    @if (resolvedIcon !== null) {
      <mat-icon [customMatSvgIcon]="resolvedIcon" />
    }
    {{ label() | resolveTranslateAbleText }}
  </button>
</div>
